import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToasterModule } from 'angular2-toaster/angular2-toaster';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-modialog';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { FlotDirective } from './directives/flot/flot.directive';
import { SparklineDirective } from './directives/sparkline/sparkline.directive';
import { EasypiechartDirective } from './directives/easypiechart/easypiechart.directive';
import { ColorsService } from './colors/colors.service';
import { CheckallDirective } from './directives/checkall/checkall.directive';
import { VectormapDirective } from './directives/vectormap/vectormap.directive';
import { NowDirective } from './directives/now/now.directive';
import { ScrollableDirective } from './directives/scrollable/scrollable.directive';
import { JqcloudDirective } from './directives/jqcloud/jqcloud.directive';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgxMaskModule } from 'ngx-mask';
import { DataTableModule } from "angular2-datatable";
import { MyDatePickerModule } from 'mydatepicker';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { AutenticacaoService } from '../service/autenticacao.service';
import { HttpModule } from '@angular/http';
import { AuthGuard } from '../auth/auth.guard';
import { BarraBotoesComponent } from './componentes/barra-botoes/barra-botoes.component';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';
import { MensagemUtilService } from '../util/mensagemutil.service';
import { CadastroModalUtil } from '../util/modal/cadastro.modal.util';
import { CampoSelect2Component } from './componentes/campo-select2/campo-select2.component';
import { CampoTelefoneComponent } from './componentes/campo-telefone/campo-telefone.component';
import { DataPickerComponent } from './componentes/data-picker/data-picker.component';
import { EnviarSmsComponent } from './componentes/enviar-sms/enviar-sms.component';
import { FileUploadModule } from 'ng2-file-upload';
import { TabelaDataTablesComponent } from './componentes/tabeladatatables/tabeladatatables.component';
import { TabelaNonPagedDataTablesComponent } from './componentes/tabelanonpageddatatables/tabelanonpageddatatables.component';
import { TelefoneDirective } from '../util/directives/telefone.directive';
import { AlterarSenhaComponent } from './componentes/alterar-senha/alterar-senha.component';
import { ImportarPermissoesComponent } from './componentes/importar-permissoes/importar-permissoes.component';
import { ConfiguracaoDashboardComponent } from './componentes/configuracao-dashboard/configuracao-dashboard.component';
import { ChartModule } from 'angular2-highcharts';
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';
import * as highcharts from 'highcharts';
import { UsuarioTemporarioComponent } from './componentes/usuario-temporario/usuario-temporario.component';
import { CustomFormsModule } from 'ng5-validation'
import { ListagemUsuarioComponent } from '../routes/usuarios/listagem-usuario/listagem-usuario.component';
import { KeyPermitidosDirective } from '../util/directives/key-permitidos.directive';

// https://angular.io/styleguide#!#04-10

export function highchartsFactory() {
    return highcharts;
}
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        ButtonsModule.forRoot(),
        CarouselModule.forRoot(),
        CollapseModule.forRoot(),
        DatepickerModule.forRoot(),
        DataTableModule,
        MyDatePickerModule,
        CurrencyMaskModule,
        NgxMaskModule.forRoot(),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        ProgressbarModule.forRoot(),
        RatingModule.forRoot(),
        TabsModule.forRoot(),
        TimepickerModule.forRoot(),
        TooltipModule.forRoot(),
        TypeaheadModule.forRoot(),
        ToasterModule,
        BootstrapModalModule,
        FileUploadModule,
        Ng4LoadingSpinnerModule.forRoot(),
        CustomFormsModule,
        ChartModule        
    ],
    providers: [
        ColorsService,
        MensagemUtilService,
        AutenticacaoService,
        CadastroModalUtil,
        AuthGuard,
        ListagemUsuarioComponent,                
        {
            provide: HighchartsStatic,
            useFactory: highchartsFactory
        }
    ],
    declarations: [
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        BarraBotoesComponent,
        CampoSelect2Component,
        DataPickerComponent,
        CampoTelefoneComponent,
        EnviarSmsComponent,
        TabelaDataTablesComponent,
        TabelaNonPagedDataTablesComponent,
        TelefoneDirective,
        AlterarSenhaComponent,
        ImportarPermissoesComponent,
        ConfiguracaoDashboardComponent,
        UsuarioTemporarioComponent,
        KeyPermitidosDirective,

    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        DatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        TypeaheadModule,
        ToasterModule,
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        Ng4LoadingSpinnerModule,
        HttpModule,
        BarraBotoesComponent,
        NgxMaskModule,
        BootstrapModalModule,
        CampoSelect2Component,
        CampoTelefoneComponent,
        DataPickerComponent,
        EnviarSmsComponent,
        FileUploadModule,
        TabelaDataTablesComponent,
        TabelaNonPagedDataTablesComponent,
        TelefoneDirective,
        AlterarSenhaComponent,
        ImportarPermissoesComponent,
        ConfiguracaoDashboardComponent,
        ChartModule,
        CustomFormsModule,
        UsuarioTemporarioComponent,
        KeyPermitidosDirective,
    ]
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts